import type { IconDefinition } from '../index.tsx';

export const iconFacebook: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconFacebook',
  icon: [
    16,
    16,
    [],
    '',
    'M15.75 8.04688C15.75 3.76562 12.2812 0.296875 8 0.296875C3.71875 0.296875 0.25 3.76562 0.25 8.04688C0.25 11.9219 3.0625 15.1406 6.78125 15.7031V10.2969H4.8125V8.04688H6.78125V6.35938C6.78125 4.42188 7.9375 3.32812 9.6875 3.32812C10.5625 3.32812 11.4375 3.48438 11.4375 3.48438V5.39062H10.4688C9.5 5.39062 9.1875 5.98438 9.1875 6.60938V8.04688H11.3438L11 10.2969H9.1875V15.7031C12.9062 15.1406 15.75 11.9219 15.75 8.04688Z',
  ],
};
